import { useTranslation } from 'react-i18next';

export default function LoadingIndicator() {
  const { t } = useTranslation('chat');

  return (
    <div className="flex justify-start" role="status" aria-live="polite">
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl px-4 py-3">
        <div className="flex items-center space-x-3" aria-hidden="true">
          <img
            src="/uel-crest.webp"
            alt=""
            className="w-8 h-8 object-contain loading-pulse"
          />
          <span className="text-sm font-medium text-gray-500 dark:text-gray-400 loading-shimmer">
            {t('pailaIsThinking')}…
          </span>
        </div>
        <span className="sr-only">{t('pailaIsThinking')}</span>
      </div>
    </div>
  );
}
